// extracted by mini-css-extract-plugin
export default {"wrapper":"Page-rebranding-module__wrapper___h-kjo"};